module.exports = __webpack_public_path__ + "img/yuanquan.33a468ec.svg";